<template lang="pug">
div
  section.profile__header#profile__header--section
    img.avatar.rounded(
      :src='profile.avatar',
      v-if='profile.avatar')
    h1.header.section-header {{ profile.realname }}
    p {{ profile.description }}
    a(:href='profile.url')
      p {{ profile.url }}

  section.profile__grid--menu(v-scroll='handleScroll')
    #profile__header--container
      .profile__grid--header
        .toggle
          .bars(
            @click='gridView = false',
            :class='{active: !gridView}')
            .bar
            .bar

          .grid(
            @click='gridView = true',
            :class='{active: gridView}')
            .square
            .square
            .square
            .square
        .profile__grid--info
          img.avatar.rounded(
            :src='profile.avatar',
            v-if='profile.avatar')
          h1.header.section-header {{ profile.realname }}

  section
    .flixel__grid
      flixel-list(
        :flixels='flixels',
        :grid-view='gridView',
        profilePage='true')
</template>

<script>
import FlixelService from 'services/flixel.es6.js';
import ProfileService from 'services/profile.es6.js';
import Scroll from 'directives/Scroll.js';
import FlixelList from 'components/FlixelList.vue';
import Slideshow from 'components/Slideshow.vue';
import EventBus from '../eventBus.js';

export default {
  name: 'Profile',
  props: ['user_name'],
  metaInfo() {
    return {
      title: this.profile.realname + ' Profile | Flixel Living Photos',
      meta: [
        {
          'property': 'image',
          'content': this.profile.avatar,
        },
        {
          'property': 'description',
          'content': this.profile.description,
        },
      ],
    };
  },
  data() {
    return {
      username: '',
      profile: '',
      flixels: '',
      gridView: false,
      version: '',
      lastScrollTop: 0,
      delta: 0,
      navbarHeight: '',
      profileHeaderSection: '',
    };
  },
  mounted() {
    const self = this;
    this.username = this.$route.params.username;
    this.loadFlixelsInvoke();
    this.profileHeaderSection = document.getElementById('profile__header--section');
    this.navbarHeight = $(this.profileHeaderSection).outerHeight();
    $('.profile__grid--info').hide();

    // Set up event listener to update view
    EventBus.$on('updateProfileView', function (username) {
      ProfileService.get(username)
        .then(function (data) {
          self.username = username;
          self.profile = data;
          self.loadFlixelsInvoke();
        }, function () {
          self.$router.push('/404/');
          return false;
        });
    });

    return ProfileService.get(this.$route.params.username)
      .then(function (data) {
        self.profile = data;
      }, function () {
        self.$router.push('/404/');
        return false;
      });
  },
  directives: {
    scroll: Scroll,
  },
  methods: {
    loadFlixelsSuccess(data) {
      this.flixels = data;
    },

    loadFlixelsError(error) {
    },

    loadFlixelsInvoke() {
      this.isLoading = true;

      FlixelService.getList(this.getOptions())
        .then(this.loadFlixelsSuccess, this.loadFlixelsError);
    },
    getOptions() {
      return {
        cache: true,
        params: {
          username: this.username,
        },
      };
    },
    hasScrolled() {
      const st = $(window).scrollTop();
      const self = this;
      // Add fixedProfile--down when scrolling down
      if (st > self.lastScrollTop && st > self.navbarHeight) {
        $('#profile__header--container').removeClass('fixedProfile--up').addClass('fixedProfile--down');
        $('.profile__grid--info').show();
      } else {
        // Add fixedProfile--up when scrolling up
        if (st + $(window).height() < $(document).height() && self.navbarHeight < st) {
          $('#profile__header--container').removeClass('fixedProfile--down').addClass('fixedProfile--up');
        } else if (st < self.lastScrollTop && st < self.navbarHeight) {
          // Remove fixedProfile--up when user is at the top of the page
          $('#profile__header--container').removeClass('fixedProfile--up');
          $('.profile__grid--info').hide();
        }
      }
      self.lastScrollTop = st;
    },
    handleScroll() {
      const self = this;
      if (Math.abs(self.lastScrollTop - $(window).scrollTop()) > self.delta) {
        this.hasScrolled();
      }
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  components: {
    'flixel-list': FlixelList,
    'slide-show': Slideshow,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Profile.vue